import React, { createContext, useContext, useMemo, useState } from 'react';
import catalogConfigService from 'services/catalogConfigService';
import i18n from 'i18n';

interface CatalogPreferencesValue {
  locale: string;
  currency: string;
  setLocale: (locale: string) => void;
  setCurrency: (currency: string) => void;
}

const CatalogPreferencesContext = createContext<CatalogPreferencesValue | undefined>(undefined);

export const CatalogPreferencesProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [locale, setLocaleState] = useState(catalogConfigService.getDefaultLocale);
  const [currency, setCurrencyState] = useState(catalogConfigService.getDefaultCurrency);

  const setLocale = (value: string) => {
    catalogConfigService.setLocale(value);
    setLocaleState(value);
    i18n.changeLanguage(value);
  };

  const setCurrency = (value: string) => {
    catalogConfigService.setCurrency(value);
    setCurrencyState(value);
  };

  const value = useMemo(
    () => ({
      locale,
      currency,
      setLocale,
      setCurrency,
    }),
    [locale, currency]
  );

  return (
    <CatalogPreferencesContext.Provider value={value}>{children}</CatalogPreferencesContext.Provider>
  );
};

export const useCatalogPreferencesContext = () => {
  const ctx = useContext(CatalogPreferencesContext);
  if (!ctx) throw new Error('useCatalogPreferencesContext debe usarse dentro de CatalogPreferencesProvider');
  return ctx;
};
